import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

import { client, clientServer } from '../../commons/httpCommon';

export async function getIdToken() {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken?.toString?.() || session.tokens?.idToken?.payload?.jwtToken || '';
  return idToken;
}

async function cognitoToken(config: any) {
  try {
    await getCurrentUser();
    const idToken = await getIdToken();
    if (idToken) {
      config.headers = { Authorization: `Bearer ${idToken}` };
    }
    return config;
  } catch {
    return config;
  }
}

export function authInterceptor() {
  client.interceptors.request.use(async (config) => cognitoToken(config));
  clientServer.interceptors.request.use(async (config) => cognitoToken(config));
}
